 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"7":"component---src-pages-dashboard-js","8":"component---src-pages-discord-identify-js","9":"component---src-pages-forum-js","10":"component---src-pages-gridniks-js","11":"component---src-pages-index-js","12":"component---src-pages-validatemail-js","13":"component---src-pages-wiki-audio-mdx","14":"component---src-pages-wiki-automation-mdx","15":"component---src-pages-wiki-community-mdx","16":"component---src-pages-wiki-contributing-mdx","17":"component---src-pages-wiki-effects-mdx","18":"component---src-pages-wiki-faq-mdx","19":"component---src-pages-wiki-grid-mdx","20":"component---src-pages-wiki-index-mdx","21":"component---src-pages-wiki-instruments-mdx","22":"component---src-pages-wiki-learning-mdx","23":"component---src-pages-wiki-midi-mdx","24":"component---src-pages-wiki-modulation-mdx","25":"component---src-pages-wiki-tips-tricks-50-limitation-relative-automations-mdx","26":"component---src-pages-wiki-tips-tricks-extracting-data-from-the-grid-mdx","27":"component---src-pages-wiki-tips-tricks-generating-sub-harmonics-through-re-synthesis-mdx","28":"component---src-pages-wiki-tips-tricks-how-to-navigate-the-entirety-of-the-popup-browser-with-keystrokes-mdx","29":"component---src-pages-wiki-tips-tricks-index-mdx","30":"component---src-pages-wiki-tips-tricks-macros-to-automate-everything-mdx","31":"component---src-pages-wiki-tips-tricks-monitor-bus-mdx","32":"component---src-pages-wiki-tips-tricks-mute-disable-mdx","33":"component---src-pages-wiki-tips-tricks-quantize-audio-so-it-sounds-clean-without-warping-mdx","34":"component---src-pages-wiki-tips-tricks-quick-percussions-slicing-mdx","35":"component---src-pages-wiki-tips-tricks-switching-tracks-mdx","36":"component---src-pages-wiki-tips-tricks-track-freeze-mdx","37":"component---src-pages-wiki-tips-tricks-using-relative-automations-and-clip-launcher-mdx","38":"component---src-pages-wiki-todo-mdx","39":"component---src-pages-wiki-ui-mdx","40":"component---src-templates-challenge-detail-js","41":"component---src-templates-challenges-js","42":"component---src-templates-preset-category-js","43":"component---src-templates-preset-creator-js","44":"component---src-templates-preset-detail-js","45":"component---src-templates-preset-device-js","46":"component---src-templates-presets-featured-js","47":"component---src-templates-presets-js","48":"component---src-templates-video-guides-js"}[chunkId]||chunkId) + "-" + {"1":"569e43fdea40e192ab5c","2":"27a7133c8fb50a4aab35","3":"c23502d3ca5d702d3ff4","4":"88210ade59adce3554ad","5":"ba3a3a19ffa7408995ce","7":"c4a338ad239534e0cee7","8":"fc6ca76ce899c13c33a3","9":"6edf3acc1964a66a11c9","10":"887b363ed669e24ae36c","11":"8672daae4c92058d6db1","12":"2af07d125b13a49f60b2","13":"295e76eaf4e42ebc6968","14":"e6a37432bf6c5abca550","15":"ade5c59cc6f89568a517","16":"7ef65f1e0f8f68a3d98e","17":"147a8ea8d3b74d68c5c7","18":"24f317150bd06628169b","19":"4117e7b9aaa7ff9fd083","20":"f07738b0bb3c7aa3906f","21":"a93b3dce627e0ac0293d","22":"c6c32baea80ac7b75049","23":"8b348bc9f48104369398","24":"4fa948e27329fdc05bc8","25":"b6eac5f7bdbfbad0232c","26":"2ba3826cfb69c50c6145","27":"8c728fa76c2cd0e99844","28":"27ded2d8a1d1038f8239","29":"87d045b7e918e539168f","30":"3d39f8634b8dba57e199","31":"511e95038e875f541e51","32":"988d79fd8034ad7cdf13","33":"26783195ff77660985ed","34":"f37994aaaaeeb60dee18","35":"4f92d2e50650c174a6a6","36":"64a9f9878b3005c3e6e1","37":"8e1824143d7fb22785dc","38":"b53329946af77a7aad68","39":"7ee1bbaf1e85e4a13b1f","40":"758cd25ad59155d4820a","41":"6e9835ff612adcdd03e4","42":"1c089e3ef8756aeec363","43":"c76eb1a4d15e4f98d584","44":"6c283d26110048156c04","45":"19cba3826b1678b4905f","46":"12d13b19e55c86cc4bbf","47":"cbf4c127fae317734cfe","48":"4874751d4ab417dd2409","50":"ecac710ab93c03f17be7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
